import './NavButtons.less';

import React from 'react';
import { isProfileIScratchCardEnabled, isProfilePromoCmsEnabled } from 'nike-ui/src/profiles';
import { FilteringSlider } from '@/nikeone/components/FilterSlider';
import { navigate } from '@/routing';
import {
    NIKE1,
    PROMO_CMS,
    SCRATCHCARD_OVERVIEW,
    TURBO_LIVE_SPORT,
    TV_NIKE_STREAM_OVERVIEW,
    VIRTUAL_GAMES
} from '@/routing/routes';
import i18n from '@i18n';
import { getProperty } from '@/common/oldMobile';
import { PROMO_DEFAULT_COLOR } from 'nike-ui/src/components/promo-cms/constants';
import NuiTag from 'nike-ui/src/components/nui-tag/NuiTag';

const PromoButton = ({ tournament }) => {
    const color = tournament.color || PROMO_DEFAULT_COLOR;
    const bgr = {
        backgroundImage: `linear-gradient(45deg, rgba(0, 0, 0, 0.4), transparent), linear-gradient(${color}, ${color})`
    };
    return tournament ? (
        <div className="mb-10 pager flex">
            <button
                className="nav-btn-new full-width px-15 py-15 flex italic br-radius-4"
                style={bgr}
                data-atid={'homepage-button-promo-cms'}
                onClick={() => navigate(PROMO_CMS, { tournament: tournament.slug })}
            >
                <span className="c-white nav-btn-shadow flex-1 text-left mr-10">{tournament.name}</span>
                <span className="nav-btn-badge c-black bg-white fs-11 text-extra-bold c-black-100 br-radius-xxxs uppercase">
                    {i18n('nui.link.promo.cms.new')}
                </span>
            </button>
        </div>
    ) : null;
};

const PromoButtons = () => {
    const promoCmsEnabled = isProfilePromoCmsEnabled();
    const promoTournaments = getProperty('activePromoTournaments');
    return promoCmsEnabled
        ? promoTournaments &&
              promoTournaments.map(tournament => <PromoButton key={tournament.slug} tournament={tournament} />)
        : null;
};

export default function NavButtons() {
    return (
        <FilteringSlider className="nav-buttons">
            <PromoButtons />
            <div className="pager">
                <button data-atid={'homepage-button-prematch'} onClick={() => navigate(NIKE1)}>
                    {i18n('nikeOne.all')}
                </button>
                <button data-atid={'homepage-button-live'} onClick={() => navigate(TURBO_LIVE_SPORT)}>
                    {i18n('nikeOne.live')}
                </button>
                <button data-atid={'homepage-button-virtuals'} onClick={() => navigate(VIRTUAL_GAMES)}>
                    {i18n('nikeOne.virtuals')}
                </button>
            </div>
            <div className="mt-10">
                {isProfileIScratchCardEnabled() ? (
                    <div className="full-width inline-flex flex">
                        <button
                            data-atid="zreby"
                            className="mr-10 p-rel"
                            onClick={() => navigate(SCRATCHCARD_OVERVIEW)}
                        >
                            {i18n('page.title.zreby')}
                            <NuiTag size="sm" otherClass="p-abs uppercase homepage-nav-tag" />
                        </button>
                        <button data-atid={'homepage-button-niketv'} onClick={() => navigate(TV_NIKE_STREAM_OVERVIEW)}>
                            {i18n('homepage.niketv.button')}
                        </button>
                    </div>
                ) : (
                    <button
                        data-atid={'homepage-button-niketv'}
                        className="full-width inline-button"
                        onClick={() => navigate(TV_NIKE_STREAM_OVERVIEW)}
                    >
                        {i18n('homepage.niketv.button')}
                    </button>
                )}
            </div>
        </FilteringSlider>
    );
}
